import { ShareLink, SocialIconInstagram } from '@economist/design-system/dist/umd/common';
import * as React from 'react';
export default {
  ShareLink,
  SocialIconInstagram,
  React
};